module.exports = __webpack_public_path__ + "static/media/igi_flash_auction_dutch.6d2e3c7c.png";